module.exports = __webpack_public_path__ + "img/title.20bcbf93.png";